import { AppBrands } from '../constants'

const environmentUtil = {
  environment: (process.env.VUE_APP_EnvironmentClass || process.env.NODE_ENV).toLowerCase(),
  appBrand: process.env.VUE_APP_AppBrand?.toLowerCase(),

  isCCFBrandEnv () {
    return environmentUtil.appBrand === AppBrands.c1l || environmentUtil.appBrand === AppBrands.ccc || environmentUtil.appBrand === AppBrands.ccf || environmentUtil.appBrand === AppBrands.chs || environmentUtil.appBrand === AppBrands.cic || environmentUtil.appBrand === AppBrands.esm || environmentUtil.appBrand === AppBrands.rpc || environmentUtil.appBrand === AppBrands.spc
  },

  isTMXBrandEnv () {
    return environmentUtil.appBrand === AppBrands.inl || environmentUtil.appBrand === AppBrands.tbs || environmentUtil.appBrand === AppBrands.tmx
  },

  isLowerEnv () {
    return environmentUtil.environment === 'development' || environmentUtil.environment === 'dev' || environmentUtil.environment === 'qa' || environmentUtil.environment === 'test' || environmentUtil.environment === 'stage'
  },

  isProdEnv () {
    return environmentUtil.environment === 'production' || environmentUtil.environment === 'prod' || environmentUtil.environment === 'beta'
  }
}

export default environmentUtil

export const getDefaultStore = () => {
  switch (process.env.VUE_APP_AppBrand) {
    case AppBrands.esm:
      return 22025

    case AppBrands.chs:
      return 80329

    case AppBrands.ccf:
      return 20267

    case AppBrands.cic:
      return 80129

    case AppBrands.inl:
      return 11635

    case AppBrands.spc:
      return 80229

    case AppBrands.rpc:
      return 80229

    case AppBrands.tmx:
    case AppBrands.tbs:
    default:
      return 17242
  }
}
